import { useAboutUs } from "../../../hooks/apis/main";
import parse from "html-react-parser";

function About_content(data) {
  return (
    <>
      <div className="about-content">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 col-12 m-auto">
              <div className="text">{parse(data.data.description)}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default About_content;
